<form
  [formGroup]="form"
  [id]="formId"
  (ngSubmit)="onChangePassword()"
  autocomplete="off"
>
  <div class="row">
    <!-- password -->
    <div [class]="responsiveClass">
      <form-field
        type="password"
        class="tw-w-full`"
        [label]="passwordLabel"
        [isShowValidationStatusIcon]="false"
        [type]="hidePassword ? 'password' : 'text'"
        [control]="form?.get('password')"
        [(value)]="password"
        [maxLength]="32"
        (input)="onChangeConfirmPassword(); onChangePassword()"
        classList="tw-text-lg dir-ltr"
      >
        <span prefix-content>
          <i class="mdi mdi-lock mdi-18px"></i>
        </span>
        <div content class="tw-relative">
          <span
            class="tw-cursor-pointer"
            mat-icon-button
            matSuffix
            (click)="hidePassword = !hidePassword"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hidePassword"
          >
          </span>
        </div>
      </form-field>
    </div>

    <!-- confirm password -->
    <div [class]="responsiveClass">
      <form-field
        class="tw-w-full"
        [label]="confirmPasswordLabel"
        [maxLength]="32"
        [isShowValidationStatusIcon]="false"
        [control]="form?.get('confirmPassword')"
        [(value)]="confirmPassword"
        (input)="onChangeConfirmPassword(); onChangePassword()"
        [type]="hidePassword ? 'password' : 'text'"
        classList="tw-text-lg dir-ltr"
      >
        <span prefix-content>
          <i class="mdi mdi-lock mdi-18px"></i>
        </span>
      </form-field>

      <mat-error>
        <!-- confirmPassword error -->
        <div
          *ngIf="
            form.get('confirmPassword')?.invalid &&
            form.get('confirmPassword')?.touched &&
            form.get('confirmPassword').errors.mismatch
          "
          class="text-danger tw-w-full tw-pr-2 tw-mb-2"
          style="margin-top: -3px"
        >
          <div class="tw-text-right tw-font-medium">
            ⁎ {{ "messages.confirmPassword" | translate }}
          </div>
        </div>

        <!-- invalid password error -->
        <div
          *ngIf="
            form.get('confirmPassword')?.invalid &&
            form.get('confirmPassword')?.touched &&
            form.get('confirmPassword').errors.pattern
          "
          class="text-danger tw-w-full tw-pr-2 tw-mb-2"
          style="margin-top: -3px"
        >
          <div class="tw-text-right tw-font-medium">
            ⁎ {{ "messages.passwordRole" | translate }}
          </div>
        </div>

        <!-- min length error -->
        <div
          *ngIf="
            form.get('confirmPassword')?.invalid &&
            form.get('confirmPassword')?.touched &&
            form.get('confirmPassword').errors.minlength
          "
          class="text-danger tw-w-full tw-pr-2 tw-mb-2"
          style="margin-top: -3px"
        >
          ⁎
          <span
            class="tw-text-right tw-font-medium"
            translate
            [translateParams]="{
              formFieldName: 'common.password' | translate,
              minLength: minLength
            }"
          >
            messages.minLength
          </span>
        </div>
      </mat-error>
    </div>

    <div
      [class]="responsiveClass + ' tw-flex-start !tw-mb-5'"
      *ngIf="showPasswordGenerator"
    >
      <password-generator
        (password)="onSetRandomPassword($event)"
      ></password-generator>
      <i
        (click)="copyToClipboard()"
        *ngIf="randomPassword"
        class="cursor-pointer mdi mdi-content-copy mdi-22px"
      ></i>
    </div>
  </div>
</form>
